module.exports = __webpack_public_path__ + "static/media/43.b5eee363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/43.jpg
// module id = 604
// module chunks = 0